/**HDMs have different level of permission compare to
*  - customer service
*  - Abbott Admin
*  and the layout is slightly different
*  Here all functionalities needed for HDM and shared with CS and AA
**/
'use strict';

import Loader from '../../../_modules/loader/loader';
import { isFieldEmpty, displayErrors, isValidEmail } from './_helper';
import { toaster } from './_material';


let $body = $('body'),
    $sendPwdPopup = $('#approve-send-pwd-link'),
    $hcpWorkplaceId = $('#HcpWorkplaceId'),
    $HcpSelect = $('#HcpName'),
    $hcpNumber = $('#UpdateNumber'),
    $hcpEmail = $('#UpdateWorkplaceEmail'),
    $hcpRole = $('#HcpType'),
    $hdpSwitch = $('.hdpPermission input[type="checkbox"]'),
    $updateRoleForm = $('#update-hcpworkplace-role-form'),
    $pwUserId = $('#HensId'),
    isCSorAA = $('.workspace').length,
    workplaceEmail = $('#EmailAddress').val(),
    currentNumber = '',
    currentRole = '',
    selectedWorkplace = '',
    _isInvalid = [],
    dataParams = {},
    loader = new Loader(),
    isConfirmAction;



/* Canceling action when clicking on the fancybox overlay */
$(document).on('change', 'body', function () {

    var $fancybox = $('.fancybox-overlay');

    if($fancybox.length){

        $('.fancybox-overlay.fancybox-overlay-fixed').on('click', function(){

            isConfirmAction = false;

            // console.log('document changed');
            setTimeout(function () {
                if(isConfirmAction){
                    // Do nothing here
                    //TODO Invert the condition block
                }else{
                    $('.js-undo-change-permission')[0].click();
                }
            }, 100);

        });
    }

});


/* Head Dietician Permission: display confirmation popup for changing permission */
$hdpSwitch.on('click', function (e){

});

$hdpSwitch.on('change', function (e){
    e.preventDefault();


    let isMobileDevice = Modernizr.mq('(max-width: 767px)'),
        workplaceId = $(this).closest('.workspace__detail').data('workplace-id');

    //needed to target right workplace for CS and AA
    $(this).addClass('selected');

    $.fancybox.open('#approve-change-permission', {
        autoSize: false,
        closeBtn: false,
        fitToView: false,
        height: isMobileDevice == true ? 300 : 200,
        width: isMobileDevice == true ? 250 : 500,
        padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
        type: 'inline',
        wrapCSS: 'modal',
        helpers: {
          overlay:{
              closeClick: true
          }
        },
        beforeClose: function(){
        }
    });

    if(isCSorAA){

        $('.js-approved-change-permission').attr('data-workplace-id', workplaceId);
    }


});


/* Head Dietician Permission: set new permission value */
$('.js-approved-change-permission').on('click', function (e){
    e.preventDefault();
    e.stopPropagation();


    var workplaceId;
    var $workplaceForm = $('#switch-hdm-permission-form');

    if(isCSorAA){
        $hdpSwitch = $('input[type="checkbox"].selected');

        workplaceId = $(this).data('workplace-id');

        $hdpSwitch.removeClass('selected');

        $workplaceForm = $('#approve-hcp__form');
    }
    else{
       workplaceId = $hcpWorkplaceId.val();
    }

    dataParams = {
        'HcpWorkplaceId': workplaceId,
        'IsManager': $hdpSwitch.prop('checked')
    };

    $.ajax({
        url: '/api/hcpworkplaces/switchhdmpermission',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        type: 'PUT',
        headers: { __RequestVerificationToken: $workplaceForm.find('input[name=__RequestVerificationToken]').val() },
        data: JSON.stringify(dataParams),
        success: function (data) {
            loader.fadeOut();

            $.fancybox.close();

            toaster('Details have been saved!');
        },
        error: function (error) {

            loader.fadeOut();
            toaster("Details couldn't be saved!");
        }
    });
});

/* Head Dietician Permission: set checkbox to original value if there is no confirmation */
$('.js-undo-change-permission').on('click', function (e){
    e.preventDefault();
    e.stopPropagation();


    if(isCSorAA){
        $hdpSwitch = $('input[type="checkbox"].selected');
        $hdpSwitch.removeClass('selected');
    }

    if($hdpSwitch.is(':checked')){
        $hdpSwitch
            .prop('checked', false)
            .parent().removeClass('checked');
    }
    else{
        $hdpSwitch
            .prop('checked', true)
            .parent().addClass('checked');
    }

    $.fancybox.close();
});


/* Approve HCP: display confirmation popup */
$('.js-approve-hcp-institution').on('click', function (e){
    e.preventDefault();

    let isMobileDevice = Modernizr.mq('(max-width: 767px)');

    $.fancybox.open('#approve-hcp-institution', {
        autoSize: false,
        closeBtn: false,
        fitToView: false,
        height: isMobileDevice == true ? 300 : 200,
        width: isMobileDevice == true ? 250 : 500,
        padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
        type: 'inline',
        wrapCSS: 'modal'
    });
});

/* Approve HCP: make API call and update values accordingly.
** Used for both views */
$('.js-confirm-approve-hcp').on('click', function (e){

    var hcpWorkId = '';

    $.fancybox.close();

    loader.fadeIn();

    // CS and AA also see a list of workplaces
    if(isCSorAA)
        hcpWorkId = $('.js-confirm-approve-hcp').data('workplace-id');
    else
        hcpWorkId = $hcpWorkplaceId.val();

    dataParams = {
        'hcpWorkplaceId': hcpWorkId
    };

    var encodedParams = jQuery.param(dataParams);

    $.ajax({
        url: '/api/hcpworkplaces/approve?' + encodedParams,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        type: 'PUT',
        headers: { __RequestVerificationToken: $('#approve-hcp__form').find('input[name=__RequestVerificationToken]').val() },
        success: function (data) {
            loader.fadeOut();

            toaster('Details have been saved!');

            //update values in current page
            if(isCSorAA)
            {
                var $selectedWorkplace = $('.workspace__row.selected');

                $selectedWorkplace
                    .find('.Status')
                    .val(data.HcpWorkplaceStatus);

                $selectedWorkplace
                    .find('.ApprovedDate')
                    .val(data.DateApproved);

                $selectedWorkplace
                    .find('.ApprovedBy')
                    .val(data.ApprovedBy);

                $selectedWorkplace
                    .find('.js-approve-workplace')
                    .hide();

                $selectedWorkplace
                    .find('.js-reject-hcp-institution')
                    .hide();

                $selectedWorkplace
                    .find('.js-remove-workplace')
                    .parent()
                    .show();

                $selectedWorkplace
                    .find('.js-reject-workplace')
                    .parent()
                    .hide();

            }
            else{
                $('.hcp-status__text').text(data.HcpWorkplaceStatus);
                $('#DateApproved').val(data.DateApproved);
                $('#ApprovedBy').val(data.ApprovedBy);
                $('.js-approve-hcp-institution').hide();
                $('.js-reject-hcp-institution').hide();
                $('.js-remove-hcp-institution').parent().show();
            }

            loader.fadeOut();

        },
        error: function (error) {
            loader.fadeOut();
            toaster('Something went wrong.');
        }
    });
});


/* Reject HCP: display confirmation popup */
$('.js-reject-hcp-institution').on('click', function (e){
    e.preventDefault();

    let isMobileDevice = Modernizr.mq('(max-width: 767px)');

    $.fancybox.open('#reject-hcp-institution', {
        autoSize: false,
        closeBtn: false,
        fitToView: false,
        height: isMobileDevice == true ? 300 : 200,
        width: isMobileDevice == true ? 250 : 500,
        padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
        type: 'inline',
        wrapCSS: 'modal'
    });
});

/* Reject HCP: make API call and update values accordingly.
** Used for both views */
$('.js-confirm-reject-hcp').on('click', function (e){

    var hcpWorkId = '';
    var requestVerificationToken;

    $.fancybox.close();

    loader.fadeIn();

    // CS and AA also see a list of workplaces
    if(isCSorAA)
    {
        requestVerificationToken = $('#approve-hcp__form').find('input[name=__RequestVerificationToken]').val();
        hcpWorkId = $('.js-confirm-reject-hcp').data('workplace-id');
    }
    else
    {
        requestVerificationToken = $('#reject-hcp__form').find('input[name=__RequestVerificationToken]').val();
        hcpWorkId = $hcpWorkplaceId.val();
    }

    dataParams = {
        'hcpWorkplaceId': hcpWorkId
    };

    var encodedParams = jQuery.param(dataParams);

    $.ajax({
        url: '/api/hcpworkplaces/reject?' + encodedParams,
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        type: 'PUT',
        headers: { __RequestVerificationToken: requestVerificationToken },
        success: function (data) {
            loader.fadeOut();

            toaster('Details have been saved!');

            //update values in current page
            if(isCSorAA)
            {
                var $selectedWorkplace = $('.workspace__row.selected');

                $selectedWorkplace
                    .find('.Status')
                    .val(data.HcpWorkplaceStatus);

                $selectedWorkplace
                    .find('.js-approve-workplace')
                    .hide();

                $selectedWorkplace
                    .find('.js-reject-workplace')
                    .hide();

                $selectedWorkplace
                    .find('#PhoneNumberDiv').removeClass('form--editable js-edit-hcp-number');

                $selectedWorkplace
                    .find('#PhoneNumberDiv > div.form--edit__link').remove();

                $selectedWorkplace
                    .find('#RoleDiv').removeClass('form--editable js-edit-hcp-number');

                $selectedWorkplace
                    .find('#RoleDiv > div.form--edit__link').remove();

                $selectedWorkplace
                    .find('.switch__input').prop('readonly',true);

                $selectedWorkplace
                    .find('.switch__label').addClass('readonly');
            }
            else{
                $('.hcp-status__text').text(data.HcpWorkplaceStatus);
                $('.js-approve-hcp-institution').hide();
                $('.js-reject-hcp-institution').hide();
                $('#PhoneNumberDiv').removeClass('form--editable js-edit-hcp-number');
                $('#PhoneNumberDiv > div.form--edit__link').remove();
                $('#RoleDiv').removeClass('form--editable js-edit-hcp-number');
                $('#RoleDiv > div.form--edit__link').remove();
                $('#HeadDieticianPermission').prop('readonly',true);
                $('#HeadDieticianPermissionLabel').addClass('readonly');
            }

            loader.fadeOut();

        },
        error: function (error) {
            loader.fadeOut();
            toaster('Something went wrong.');
        }
    });
});


/* Remove HCP: display confirmation popup */
$('.js-remove-hcp-institution').on('click', function (e){
    e.preventDefault();

    let isMobileDevice = Modernizr.mq('(max-width: 767px)');

    $.fancybox.open('#remove-hcp-institution', {
        autoSize: false,
        closeBtn: false,
        fitToView: false,
        height: isMobileDevice == true ? 300 : 200,
        width: isMobileDevice == true ? 250 : 500,
        padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
        type: 'inline',
        wrapCSS: 'modal'
    });
});

/* Remove HCP: display modal window to transfer regimen */
$('.js-confirm-remove-hcp').on('click', function (e){
    e.preventDefault();

    var institutionName = $('#HcpInstitution option:selected').text();

    $.fancybox.close();

    $('.form-modal--remove-hcp-institution').slideDown({
        duration: 500,
        easing: 'easeOutExpo',
        queue: false,
        complete: function () {
            $body.addClass('fixed');
        }
    });
});

/* Remove HCP:
** - Regimens need to be transferred to another available HCP if current HCP is removed
** - Used for both views 
** note: same functionality is used if a HCPs want to remove themselves
*/
$('.js-transfer-regimen-to-hcp').on('click', function(e){
    e.preventDefault();

    // Define where to display ajax errors
    let $errorContainer = $('.form-modal--remove-hcp-institution .server-errors__wrap');

    _isInvalid = [];

    if ($HcpSelect.val() == '') {
        $HcpSelect
            .parent().addClass('incomplete')
            .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

        _isInvalid.push(0);
    }

    if (_isInvalid.length > 0) {
        $(this).addClass('error');
        return false;
    } else {
        _isInvalid = [];

        $(this).removeClass('error');
        loader.fadeIn();

        // CS, AA, HCPs also see a list of workplaces
        if(isCSorAA){
            dataParams = {
                'HcpWorkplaceIdToRemove': $(this).attr('data-workplace-id'),
                'HcpWorkplaceIdTransferTo' : $HcpSelect.val()
            };
        }else{
            dataParams = {
                'HcpWorkplaceIdToRemove': $hcpWorkplaceId.val(),
                'HcpWorkplaceIdTransferTo' : $HcpSelect.val()
            };
        }

        $.ajax({
            url: '/api/hcpworkplaces/remove',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            type: 'PUT',
            headers: { __RequestVerificationToken: $('#remove-hcpworkplace-form').find('input[name=__RequestVerificationToken]').val() },
            data: JSON.stringify(dataParams),
            success: function (data) {
                loader.fadeOut();

                toaster('Details have been saved!');

                //update values in current page
                if(isCSorAA)
                {
                    var $selectedWorkplace = $('.workspace__row.selected');

                    $selectedWorkplace
                        .find('.Status')
                        .val(data.HcpWorkplaceStatus);

                    $selectedWorkplace
                        .find('.RemovedDate')
                        .val(data.DateRemoved);

                    $selectedWorkplace
                        .find('.js-remove-workplace')
                        .hide();

                $selectedWorkplace
                    .find('#PhoneNumberDiv').removeClass('form--editable js-edit-hcp-number');

                $selectedWorkplace
                    .find('#PhoneNumberDiv > div.form--edit__link').remove();

                $selectedWorkplace
                    .find('#RoleDiv').removeClass('form--editable js-edit-hcp-number');

                $selectedWorkplace
                    .find('#RoleDiv > div.form--edit__link').remove();

                $selectedWorkplace
                    .find('.switch__input').prop('readonly',true);

                $selectedWorkplace
                    .find('.switch__label').addClass('readonly');
                }
                else{
                    $('.hcp-status__text').text(data.HcpWorkplaceStatus);
                    $('#DateRemoved').val(data.DateRemoved);
                    $('.js-remove-hcp-institution').hide();
                    $('#PhoneNumberDiv').removeClass('form--editable js-edit-hcp-number');
                    $('#PhoneNumberDiv > div.form--edit__link').remove();
                    $('#RoleDiv').removeClass('form--editable js-edit-hcp-number');
                    $('#RoleDiv > div.form--edit__link').remove();
                    $('#HeadDieticianPermission').prop('readonly',true);
                    $('#HeadDieticianPermissionLabel').addClass("readonly");
                }

                //close current modal
                $('.js-collapse-form-modal').trigger('click');

                $errorContainer.slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });

            },
            error: function (error) {

                loader.fadeOut();
                displayErrors(error, $errorContainer );
            }
        });
    }

});


/* HCP role: display modal to edit HCP role */
$('.js-edit-hcp-role').on('click', function (e) {
    e.preventDefault();

    let $editRoleModal = $('.form-modal--update-hcp-role');

    if(isCSorAA){

        let $row = $(this).closest('.workspace__row');

        $('.workspace__row').removeClass('selected');
        $row.addClass('selected');

        //set values in the modal
        currentRole = $(this).data('role-id');
        $hcpRole.val(currentRole);
        selectedWorkplace = $(this).closest('.workspace__detail').data('workplace-id'),

        $('.js-update-hcp-role').attr('data-id', selectedWorkplace);
    }

    $editRoleModal.slideDown({
        duration: 500,
        easing: 'easeOutExpo',
        queue: false,
        complete: function () {
            $body.addClass('fixed');
        }
    });

});

/* HCP role: make API call to update HCP role */
$('.js-update-hcp-role').on('click', function (e) {
    e.preventDefault();

    // Define where to display ajax errors
    let $errorContainer = $('.form-modal--update-hcp-role .server-errors__wrap');

	if ($hcpRole.val() == '') {
        $hcpRole
            .parent().addClass('incomplete')
            .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

        $(this).addClass('error');
        return false;
    }
	else {

		$(this).removeClass('error');
        loader.fadeIn();

        if(isCSorAA){
            dataParams = {
                'HcpWorkplaceId': $(this).data('id'),
                'RoleId' : $hcpRole.val()
            };
        }else{
            dataParams = {
                'HcpWorkplaceId': $hcpWorkplaceId.val(),
                'RoleId' : $hcpRole.val()
            };
        }

        $.ajax({
            url: '/api/hcpworkplaces/updaterole',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            type: 'PUT',
            headers: { __RequestVerificationToken: $updateRoleForm.find('input[name=__RequestVerificationToken]').val() },
            data: JSON.stringify(dataParams),
            success: function (data) {
                loader.fadeOut();

                //update value in current page
                if(isCSorAA)
                {
                    var $selectedWorkplace = $('.workspace__row.selected');

                    $selectedWorkplace
                        .find('.HcpType')
                        .val($hcpRole.find('option:selected').text());
                }
                else{
                    $('#Role').val($hcpRole.find('option:selected').text());
                }

                //close current modal
                $('.js-collapse-form-modal').trigger('click');

                $errorContainer.slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });

                toaster('Details have been saved!');
            },
            error: function (error) {

                loader.fadeOut();
                displayErrors(error, $errorContainer );
            }
        });
    }
});


/* HCP number: display modal to edit HCP number */
$('.js-edit-hcp-number').on('click', function (e) {
    e.preventDefault();

    let $editNumberModal = $('.form-modal--update-hcp-number'),
        $row = $(this).closest('.workspace__row');

    if(isCSorAA){
        //set value in the modal
        currentNumber = $(this).find('.PhoneNumber').val();
        $hcpNumber.val(currentNumber);
        selectedWorkplace = $(this).closest('.workspace__detail').data('workplace-id');

        $('.js-update-hcp-number').attr('data-id', selectedWorkplace);

        $('.workspace__row').removeClass('selected');
        $row.addClass('selected');
    }

    $editNumberModal.slideDown({
        duration: 500,
        easing: 'easeOutExpo',
        queue: false,
        complete: function () {
            $body.addClass('fixed');
        }
    });

});

/* HCP number: make API to update value */
$('.js-update-hcp-number').on('click', function (e) {
    e.preventDefault();

    // Define where to display ajax errors
    let $errorContainer = $('.form-modal--update-hcp-role .server-errors__wrap'),
        phoneRegEx = /^[0-9]{8,10}$/;

    if (isFieldEmpty($hcpNumber) || !$hcpNumber.val().match(phoneRegEx)) {
        $hcpNumber
            .parent().addClass('incomplete')
            .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

        $(this).addClass('error');
        return false;
    }
    else {

        $(this).removeClass('error');
        loader.fadeIn();

        if(isCSorAA){
            dataParams = {
                'HcpWorkplaceId': $(this).data('id'),
                'PhoneNumber' : $hcpNumber.val()
            };
        }else{
            dataParams = {
                'HcpWorkplaceId': $hcpWorkplaceId.val(),
                'PhoneNumber' : $hcpNumber.val()
            };
        }

        $.ajax({
            url: '/api/hcpworkplaces/updatephonenumber',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            type: 'PUT',
            headers: { __RequestVerificationToken: $('#update-hcpworkplace-phonenumber-form').find('input[name=__RequestVerificationToken]').val() },
            data: JSON.stringify(dataParams),
            success: function (data) {
                loader.fadeOut();

                toaster('Details have been saved!');

                //update value in current page
                if(isCSorAA)
                {
                    var $selectedWorkplace = $('.workspace__row.selected');

                    $selectedWorkplace
                        .find('.PhoneNumber')
                        .val($('#UpdateNumber').val());
                }
                else{
                    $('#InstitutionPhoneNumber').val($hcpNumber.val());
                }

                //close current modal
                $('.js-collapse-form-modal').trigger('click');

                $errorContainer.slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });
            },
            error: function (error) {

                loader.fadeOut();
                displayErrors(error, $errorContainer );
            }
        });
    }
});

//allow hcp email to be updated
/* HCP email: display modal to edit HCP email */
$('.js-edit-hcp-email').on('click', function (e) {
    e.preventDefault();

    let $editEmailModal = $('.form-modal--update-hcp-email'),
        $row = $(this).closest('.workspace__row');

    if(isCSorAA){
        //set value in the modal
        let currentEmail = $(this).find('.Email').val();
        $hcpEmail.val(currentEmail);
        selectedWorkplace = $(this).data('workplace-id');

        $('.js-update-hcp-email').attr('data-id', selectedWorkplace);

        $('.workspace__row').removeClass('selected');
        $row.addClass('selected');
    }

    $editEmailModal.slideDown({
        duration: 500,
        easing: 'easeOutExpo',
        queue: false,
        complete: function () {
            $body.addClass('fixed');
            $hcpEmail.trigger('focus');
        }
    });

});

/* HCP email: make API to update value */
$('.js-update-hcp-email').on('click', function (e) {
    e.preventDefault();

    // Define where to display ajax errors
    let $errorContainer = $('.form-modal--update-hcp-email .server-errors__wrap');

    if (isFieldEmpty($hcpEmail) || !isValidEmail($hcpEmail.val())) {
        $hcpNumber
            .parent().addClass('incomplete')
            .find('.error').slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false
            });

        $(this).addClass('error');
        return false;
    }
    else {

        $(this).removeClass('error');
        loader.fadeIn();

        if(isCSorAA){
            dataParams = {
                'HcpWorkplaceId': $(this).data('id'),
                'Email' : $hcpEmail.val()
            };
        }else{
            dataParams = {
                'HcpWorkplaceId': $hcpWorkplaceId.val(),
                'Email' : $hcpEmail.val()
            };
        }

        $.ajax({
            url: '/api/hcpworkplaces/updateemail',
            dataType: 'json',
            contentType: 'application/json; charset=utf-8',
            type: 'PUT',
            headers: { __RequestVerificationToken: $('#update-hcpworkplace-email-form').find('input[name=__RequestVerificationToken]').val() },
            data: JSON.stringify(dataParams),
            success: function (data) {
                loader.fadeOut();

                toaster('Details have been saved!');

                //update value in current page
                if(isCSorAA)
                {
                    var $selectedWorkplace = $('.workspace__row.selected');

                    $selectedWorkplace
                        .find('.Email')
                        .val($hcpEmail.val());
                }
                else{
                    $('#InstitutionEmail').val($hcpEmail.val());
                }

                //close current modal
                $('.js-collapse-form-modal').trigger('click');

                $errorContainer.slideUp({
                    duration: 500,
                    easing: 'easeInOutExpo',
                    queue: false
                });
            },
            error: function (error) {

                loader.fadeOut();
                displayErrors(error, $errorContainer );
            }
        });
    }
});


//display confirmation popup for sending the pwd reset link
$('.js-send-pwd-link').on('click', function (e){
    e.preventDefault();

    let isMobileDevice = Modernizr.mq('(max-width: 767px)');

    $.fancybox.open('#approve-send-pwd-link', {
        autoSize: false,
        closeBtn: false,
        fitToView: false,
        height: isMobileDevice == true ? 300 : 200,
        width: isMobileDevice == true ? 250 : 500,
        padding: isMobileDevice == true ? 15 : [15, 25, 15, 25],
        type: 'inline',
        wrapCSS: 'modal'
    });

});

//send request to reset password
$('.js-approved-send-pwd-link').on('click', function(e){
    e.preventDefault();

    let message = '';

    dataParams = {
        'UserId': $pwUserId.val()
    };

    $.ajax({
        url: '/api/account/sendresetpasswordlink',
        dataType: 'json',
        contentType: 'application/json; charset=utf-8',
        type: 'PUT',
        headers: { __RequestVerificationToken: $('#frm-send-reset-passwordlink').find('input[name=__RequestVerificationToken]').val() },
        data: JSON.stringify(dataParams),
        success: function (data) {
            message = 'If an account exists with the email you entered, a reset password link will be sent to ' + $('.header-section h1').text();
        },
        error: function (error) {
            message = "Something went wrong. Details couldn't be saved.";
        },
        complete: function(){
            $sendPwdPopup.find('p').text(message);
            $sendPwdPopup.find('.js-approved-send-pwd-link').hide();
            $sendPwdPopup.find('.js-fancybox-close').text('ok');
        }
    });

});
